"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var HeaderCharm_1 = require("./HeaderCharm");
var owa_header_pane_1 = require("owa-header-pane");
var mobx_react_1 = require("mobx-react");
var FeatureFlagsCharm = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsCharm, _super);
    function FeatureFlagsCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsCharm.prototype.render = function () {
        return (React.createElement(HeaderCharm_1.default, { title: "Feature Flags", key: "featureflags", icons: { iconName: "Flag" /* Flag */ }, ariaLabel: "featureflags charm" // No need to localize as it is a DEV feature only
            , behavior: {
                paneComponent: owa_header_pane_1.FeatureFlagsPane,
                charm: 1 /* FeatureFlagsCharm */,
            } }));
    };
    FeatureFlagsCharm = tslib_1.__decorate([
        mobx_react_1.observer
    ], FeatureFlagsCharm);
    return FeatureFlagsCharm;
}(React.Component));
exports.default = FeatureFlagsCharm;
//# sourceMappingURL=FeatureFlagsCharm.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header/lib/components/FeatureFlagsCharm.js
// module id = 6245
// module chunks = 42